import { createFileRoute, redirect } from '@tanstack/react-router';

import { SelectCoursePage } from '@/pages/payments';

export const Route = createFileRoute('/_user/payment/select-course')({
  beforeLoad: async ({ context }) => {
    const user =
      context.auth.user ?? (await context.auth.userRefetch().catch(() => null));

    if (!user) {
      throw redirect({ to: '/sign-in' });
    }

    if (!user.is_email_verified) {
      throw redirect({
        to: '/verify-email',
        search: {
          email: user.email,
          token: undefined,
        },
      });
    }

    if (user?.user_can_take) {
      throw redirect({ to: '/courses' });
    }
  },
  validateSearch: (search: Record<string, string>) => ({
    status: search.status ? search.status : undefined,
    session_id: search.session_id ? search.session_id : undefined,
  }),
  component: SelectCoursePage,
});
